import {
  FileEdit,
  Clock,
  Send,
  CheckCircle,
  XCircle,
  Ban,
} from "lucide-react";
import type { TaxDocumentStatus } from "../types";
import { STATUS_LABELS, STATUS_COLORS } from "../types";

interface StatusBadgeProps {
  status: TaxDocumentStatus;
  showIcon?: boolean;
}

const STATUS_ICONS: Record<TaxDocumentStatus, typeof Clock> = {
  draft: FileEdit,
  pending: Clock,
  submitted: Send,
  accepted: CheckCircle,
  rejected: XCircle,
  cancelled: Ban,
};

export function StatusBadge({ status, showIcon = true }: StatusBadgeProps) {
  const Icon = STATUS_ICONS[status];
  const label = STATUS_LABELS[status];
  const colorClass = STATUS_COLORS[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {label}
    </span>
  );
}
